import { compose } from 'redux';
import { infrastructureFulfilledConstants } from '../actions';
import { getSorting, stableSort } from '../utils';

const initialState = {
    whereabouts: [],
    locations: [],
    osVersions: [],
    screenSizes: []
};

const configuredStableSort = compose(stableSort, getSorting)('asc', 'name');

export default function (state = initialState, action) {
    switch (action.type) {
        case infrastructureFulfilledConstants.INFRASTRUCTURE_LOADED:
            const infrastructure = {
                ...state,
                ...action.payload
            };

            Object.keys(infrastructure).forEach(key => {
                if (action.payload[key] instanceof Array) {

                    if (key === 'osVersions') {
                        infrastructure.osVersions = configuredStableSort(infrastructure.osVersions);
                    }
                }
            });

            return infrastructure;
        default:
            return state;
    }
}
